import { useEffect, useState } from "react";
import { ReactLenis } from "lenis/react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeBanner from "@/components/MarqueeBanner";
import Ideas from "@/components/Ideas";
import Manifesto from "@/components/Manifesto";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  const [ideas, setIdeas] = useState([]);

  useEffect(() => {
    api
      .get("/ideas")
      .then((r) => setIdeas(r.data))
      .catch(() => setIdeas([]));
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App bg-[#f4f4f2]">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <MarqueeBanner text="100 Idee per Verona" speed={35} />
          <Ideas ideas={ideas} />
          <Manifesto ideas={ideas} />
          <MarqueeBanner text="Costruiamo Verona" dark speed={35} direction="right" />
          <Contact />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
